import styled from "styled-components";

export const Checkbox = styled.span`
    flex-shrink: 0;
    width: var(--checkbox-width);
    height: var(--checkbox-height);

    border: 1px solid var(--checkbox-border-color);
    background-color: var(--checkbox-background-color);
    border-radius: var(--checkbox-border-radius);
    margin: var(--checkbox-margin);

    transition: 0.3s;

    position: relative;

    svg {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%, -50%);
        width: var(--checkbox-check-size);
        height: var(--checkbox-check-size);
        stroke: var(--checkbox-check-color);
        stroke-width: var(--checkbox-check-stroke-width);
    }

    input:focus ~ & {
        box-shadow: 0 0 0 4px var(--checkbox-ring-color);
    }
`;
